<template>
  <div class="wspo-error wspo-icon">{{ errorText }}</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { i18n } from '@/functions';

export default {
  name: 'Error',
  props: {
    code: String
  },
  computed: {
    ...mapState(['errors']),
    ...mapGetters(['isError']),
    errorText() {
      return !this.code
        ? this.errors
            .map(err => (i18n.errors[err] ? i18n.errors[err] : err))
            .join(', ')
        : i18n.errors[this.code];
    }
  }
};
</script>

<style scoped>
.wspo-error {
  padding: 24px;
  position: relative;
  background-color: var(--color-bg);
  border-top: 8px solid var(--color-second);
  display: flex;
  align-items: center;
  justify-content: center;
}
.wspo-error:before {
  content: '\f071';
  margin-right: 10px;
  font-size: 24px;
  width: 32px;
  color: var(--color-second);
}
</style>
